import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { MatDivider } from '@angular/material/divider';

import { ChatStateService } from '@lib/chat/services/chat-state.service';

import { formatDate } from '@lib/commons/util-functions/format-date.function';

import { MemberContract } from '@lib/core/models/contract.interface';
import { MemberProfile } from '@lib/core/models/member.interface';

import { HealthStatusCheckSchedulerComponent, MemberCommentsListComponent } from '@lib/members/ui';

import { ContractItemComponent } from '@lib/shared-ui/commons/contract-item/contract-item.component';

@Component({
  selector: 'chat-user-profile',
  standalone: true,
  imports: [MatDivider, TranslatePipe, ContractItemComponent, HealthStatusCheckSchedulerComponent, MemberCommentsListComponent],
  styles: `
    :host {
      @apply h-full;
    }
  `,
  templateUrl: './chat-user-profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatUserProfileComponent {
  protected readonly chatState = inject(ChatStateService);
  protected readonly formatDate = formatDate;

  member = input.required<MemberProfile>();
  memberContracts = input.required<MemberContract[]>();
}
